import { get, post, put, destroy } from ".";

export function CreateAccountSetting(vid: string, options = {}) {
    return post<any>(`/app/api/accounts/${vid}/settings`, options);
}

export function DestroyAccountSetting(accountVid: string, settingVid: string) {
    return destroy<any>(`/app/api/accounts/${accountVid}/settings/${settingVid}`);
}

export function GetAccounts(options = {}) {
    return get<any>("/app/api/accounts", options);
}

export function GetAccountSettings(vid: string) {
    return get<any>(`/app/api/accounts/${vid}/settings`);
}

export function GetDeletedAccounts(options = {}) {
    return get<any>(`/app/api/accounts/deleted`, options);
}

export function GetFedDncSettingsAccounts(options = {}) {
	return get<any>(`/app/api/accounts/fed_dnc_settings`, options)
}

export function FindAccount(vid: number) {
    return get<any>(`/app/api/accounts/${vid}`);
}

export function UpdateAccount(vid: string, options = {}) {
    return put<any>(`/app/api/accounts/${vid}`, options)
}

export function UpdateAccountSetting(accountVid: string, settingVid: string, options = {}) {
    return put<any>(`/app/api/accounts/${accountVid}/settings/${settingVid}`, options);
}

export function UpdateHoldIvrStatusForAccount(accountId: string, options = {}) {
	return put<any>(`/app/api/accounts/${accountId}/hold_ivr_status`, options);
}

export function UpdateAllAccountOrgsOverridesCustomerCallerId(accountId: string, options = {}) {
	return put<any>(`/app/api/accounts/${accountId}/overrides_customer_caller_id`, options);
}

export function DestroyAccount(id: string, options = {}) {
	return destroy<any>(`/app/api/accounts/${id}`, options)
}

export function RestoreAccount(id: string) {
    return put<any>(`/app/api/accounts/${id}/restore`);
}

